import Radio from './src/radio';

export default Radio;
